/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Checklist item type, eg RESIDENCE_PERMIT/USA which represents USA Green Card
 * @export
 * @interface PaxCheckChecklistItemType
 */
export interface PaxCheckChecklistItemType {
    /**
     * Checklist item type
     * @type {string}
     * @memberof PaxCheckChecklistItemType
     */
    itemType: string;
    /**
     * Item type territory, might be null
     * @type {string}
     * @memberof PaxCheckChecklistItemType
     */
    itemTerritory?: string | null;
}

/**
 * Check if a given object implements the PaxCheckChecklistItemType interface.
 */
export function instanceOfPaxCheckChecklistItemType(value: object): value is PaxCheckChecklistItemType {
    if (!('itemType' in value) || value['itemType'] === undefined) return false;
    return true;
}

export function PaxCheckChecklistItemTypeFromJSON(json: any): PaxCheckChecklistItemType {
    return PaxCheckChecklistItemTypeFromJSONTyped(json, false);
}

export function PaxCheckChecklistItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistItemType {
    if (json == null) {
        return json;
    }
    return {
        
        'itemType': json['item_type'],
        'itemTerritory': json['item_territory'] == null ? undefined : json['item_territory'],
    };
}

export function PaxCheckChecklistItemTypeToJSON(json: any): PaxCheckChecklistItemType {
    return PaxCheckChecklistItemTypeToJSONTyped(json, false);
}

export function PaxCheckChecklistItemTypeToJSONTyped(value?: PaxCheckChecklistItemType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item_type': value['itemType'],
        'item_territory': value['itemTerritory'],
    };
}

